module.exports = __webpack_public_path__ + "static/media/icon-pending.e2938acc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-pending.svg
// module id = 1266
// module chunks = 19